import { render, staticRenderFns } from "./MagazineListTable.vue?vue&type=template&id=984bcf84&scoped=true&lang=html&"
import script from "./MagazineListTable.vue?vue&type=script&lang=js&"
export * from "./MagazineListTable.vue?vue&type=script&lang=js&"
import style0 from "./MagazineListTable.vue?vue&type=style&index=0&id=984bcf84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984bcf84",
  null
  
)

export default component.exports